import axios from 'axios';

const PortalMockRecord= {
    namespaced: true,
    actions: {
        CreateMockRecord({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}MockRecord/CreateMockRecord`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },       
        GetStudentForMockRecord({ rootState }, { MockId, SubjectId, SessionId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}MockRecord/GetStudentForMockRecord?MockId=${MockId}&SubjectId=${SubjectId}&SessionId=${SessionId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },        
    }
}

export default PortalMockRecord